// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2nrlj","boxTitle":"Qualiphy_boxTitle__3ptt1","box":"Qualiphy_box__2mdyR","toggleWrap":"Qualiphy_toggleWrap__18bON"};